export const GetAllPropertiesByLandlord = {
  GET_ALL_PROPERTIES_REQ: "GET_ALL_PROPERTIES_REQ",
  GET_ALL_PROPERTIES_SUCC: "GET_ALL_PROPERTIES_SUCC",
  GET_ALL_PROPERTIES_FAIL: "GET_ALL_PROPERTIES_FAIL",
};

export const CreateNewPropertyActionConst = {
  CREATE_NEW_PROPERTY_REQ: "CREATE_NEW_PROPERTY_REQ",
  CREATE_NEW_PROPERTY_SUCC: "CREATE_NEW_PROPERTY_SUCC",
  CREATE_NEW_PROPERTY_FAIL: "CREATE_NEW_PROPERTY_FAIL",
  CREATE_NEW_PROPERTY_CLEAR: "CREATE_NEW_PROPERTY_CLEAR",
};

export const UpdatePropertyActionConst = {
  UPDATE_PROPERTY_REQ: "UPDATE_PROPERTY_REQ",
  UPDATE_PROPERTY_SUCC: "UPDATE_PROPERTY_SUCC",
  UPDATE_PROPERTY_FAIL: "UPDATE_PROPERTY_FAIL",
  UPDATE_PROPERTY_CLEAR: "UPDATE_PROPERTY_CLEAR",
};

export const ChangePropertyCreateStepsActionConst = {
  CHANGE_PROPERTY_STEPS: "CHANGE_PROPERTY_STEPS",
};

export const createPropertyActionConst = {
  CREATE_PROPERTY_STEP_ONE: "CREATE_PROPERTY_STEP_ONE",
  CREATE_PROPERTY_STEP_TWO: "CREATE_PROPERTY_STEP_TWO",
  CREATE_PROPERTY_STEP_THREE: "CREATE_PROPERTY_STEP_THREE",
  CREATE_PROPERTY_STEP_FOUR: "CREATE_PROPERTY_STEP_FOUR",
};

export const GetPropertyDetailsActionConst = {
  GET_PROPERTY_DETAIL_REQ: "GET_PROPERTY_DETAIL_REQ",
  GET_PROPERTY_DETAIL_SUCC: "GET_PROPERTY_DETAIL_SUCC",
  GET_PROPERTY_DETAIL_FAIL: "GET_PROPERTY_DETAIL_FAIL",
};

export const ChangePropertyStatusActionConst = {
  CHANGE_PROPERTY_STATUS_REQ: "CHANGE_PROPERTY_STATUS_REQ",
  CHANGE_PROPERTY_STATUS_SUCC: "CHANGE_PROPERTY_STATUS_SUCC",
  CHANGE_PROPERTY_STATUS_FAIL: "CHANGE_PROPERTY_STATUS_FAIL",
};
export const GetPropertyMasterDataActionConst = {
  GET_PROPERTY_MASTERDATA: "GET_PROPERTY_MASTERDATA",
};

export const ClearAllPrevStateActionConst = {
  CLEAT_ALL_PREV_STATE: "CLEAT_ALL_PREV_STATE",
};

export const SetMerchantDetailsActionConst = {
  SET_MERCHANT_DETAILS: "SET_MERCHANT_DETAILS",
};
